//
// Module for the GL Account Assignment Detail view
//
rs.module("system/configuration/glaccountassignments/assignmentdetail",
        
    [
        "common/select-helper",
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (selectHelper, visibility, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrl) {
            var form = $.js(jsSelectors.form);
            var glAccountAssignmentKey = form.js(jsSelectors.glAccountAssignmentKey);
            var loadCriteriaButton = form.js(jsSelectors.loadCriteriaButton);
            var glSourceSelect = form.js(jsSelectors.glSourceSelect);
            var selectedSourcesError = form.js(jsSelectors.selectedSourcesError);
            var glCriteriaContainer = form.js(jsSelectors.glCriteriaContainer);
            var glTransactionTypeSelect = form.js(jsSelectors.glTransactionTypeSelect);
            var glTransactionTypeSelectHelper = selectHelper.getHelper(glTransactionTypeSelect);
            var glAttributesSelect = form.js(jsSelectors.glAttributesSelect);
            var glAttributesSelectHelper = selectHelper.getHelper(glAttributesSelect);
            var saveButton = form.js(jsSelectors.saveButton);

            loadCriteriaButton.on("click", function () {
                // clear event banner
                eventBanner.removeAllMessages();

                if ((glSourceSelect.val().length > 0)) {
                    var selectedTypes = glTransactionTypeSelect.val();
                    var selectedAttributes = glAttributesSelect.val();
                    $.ajax(
                        {
                            url: backendUrl,
                            data: { glSources: glSourceSelect.val().map(Number), glAccountAssignmentKey: glAccountAssignmentKey.val() },
                            traditional: true
                        })
                        .done(function (data) {
                            glTransactionTypeSelectHelper.replaceOptions(data.transactionTypes);
                            glAttributesSelectHelper.replaceOptions(data.attributes);
                            glTransactionTypeSelectHelper.setValue(selectedTypes);
                            glAttributesSelectHelper.setValue(selectedAttributes);
                            visibility.show(glCriteriaContainer);
                            visibility.show(saveButton);
                            saveButton.setDisabled(false);
                        });
                }
                else {
                    selectedSourcesError.text('GL Source is required.');
                }
            });

            glSourceSelect.on("change", function () {
                selectedSourcesError.text('');
                visibility.hide(glCriteriaContainer);
                visibility.hide(saveButton);
                saveButton.setDisabled();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);